<template>
    <a-result status="403" title="403" sub-title="您无权限访问此页面，如有疑问请联系管理人员">
        <template #extra>
            <a-button type="primary" @click="toIndex">
                回到主页
            </a-button>
        </template>
    </a-result>
</template>
<script>
export default {
    name: 'UI403',
    methods: {
        toIndex() {
            this.$router.replace('/')
        }
    }
}
</script>
